import { getUrlPathName } from "./getUrlPathName";

/**
 * "/en/ui-kit/filters?r=0" === "/en/ui-kit/filters" => true
 * "/en/ui-kit/?r=0" === "/en/ui-kit/filters?r=0" => false
 */
export const compareLocationPathNames = (first: string, second: string) => getUrlPathName(first) === getUrlPathName(second);
